module.exports = __webpack_public_path__ + "static/media/tools-highliter.109d8e5e.svg";